/* eslint-disable */
/* tslint:disable */

/** checkIfWorkerInInstitutionCountry
 * method: get
 * summary: Check if a worker is linked to at least one institution with the provided country
 */

import type {
  IsInInstitutionCountryResultDto,
  ApiResponseDto,
} from './../api-types'

export const getPath = (country: string): string =>
  `/bff-worker/profile/is-in-institution-country/${country}`
export const getFullPath = (country: string): string =>
  `${process.env.BFF_WORKER_BASE_URL || 'http://bff-worker.svc.cluster.local'}/bff-worker/profile/is-in-institution-country/${country}`

export type CheckIfWorkerInInstitutionCountrySuccess =
  IsInInstitutionCountryResultDto
export type CheckIfWorkerInInstitutionCountryError = ApiResponseDto
